// Generated from CustomAxisLexer.g4 by ANTLR 4.8
// jshint ignore: start
import antlr4 from 'antlr4/index';



var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0002\u0013\u016b\b\u0001\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t",
    "\u0003\u0004\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004",
    "\u0007\t\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b",
    "\u0004\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004",
    "\u0010\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t",
    "\u0013\u0004\u0014\t\u0014\u0003\u0002\u0003\u0002\u0003\u0003\u0003",
    "\u0003\u0003\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006\u0003",
    "\u0006\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0005\u0007\u00fd\n\u0007\u0003\b\u0003",
    "\b\u0003\b\u0003\b\u0003\b\u0003\b\u0005\b\u0105\n\b\u0003\t\u0003\t",
    "\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003",
    "\t\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003",
    "\u000b\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003\f\u0003\f\u0003",
    "\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003",
    "\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003",
    "\f\u0003\f\u0003\f\u0003\f\u0005\f\u0136\n\f\u0003\r\u0006\r\u0139\n",
    "\r\r\r\u000e\r\u013a\u0003\r\u0003\r\u0006\r\u013f\n\r\r\r\u000e\r\u0140",
    "\u0005\r\u0143\n\r\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003",
    "\u000e\u0003\u000f\u0006\u000f\u014b\n\u000f\r\u000f\u000e\u000f\u014c",
    "\u0003\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0011\u0006\u0011",
    "\u0154\n\u0011\r\u0011\u000e\u0011\u0155\u0003\u0012\u0003\u0012\u0003",
    "\u0012\u0003\u0012\u0007\u0012\u015c\n\u0012\f\u0012\u000e\u0012\u015f",
    "\u000b\u0012\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0014",
    "\u0006\u0014\u0166\n\u0014\r\u0014\u000e\u0014\u0167\u0003\u0014\u0003",
    "\u0014\u0002\u0002\u0015\u0004\u0003\u0006\u0004\b\u0005\n\u0006\f\u0007",
    "\u000e\b\u0010\t\u0012\n\u0014\u000b\u0016\f\u0018\r\u001a\u000e\u001c",
    "\u000f\u001e\u0010 \u0002\"\u0002$\u0011&\u0012(\u0013\u0004\u0002\u0003",
    "\u0006\u0004\u0002,,11\u0004\u0002--//\u0005\u0002\u000b\f\u000e\u000f",
    "\"\"\u0003\u0002\u007f\u007f\u0002\u0199\u0002\u0004\u0003\u0002\u0002",
    "\u0002\u0002\u0006\u0003\u0002\u0002\u0002\u0002\b\u0003\u0002\u0002",
    "\u0002\u0002\n\u0003\u0002\u0002\u0002\u0002\f\u0003\u0002\u0002\u0002",
    "\u0002\u000e\u0003\u0002\u0002\u0002\u0002\u0010\u0003\u0002\u0002\u0002",
    "\u0002\u0012\u0003\u0002\u0002\u0002\u0002\u0014\u0003\u0002\u0002\u0002",
    "\u0002\u0016\u0003\u0002\u0002\u0002\u0002\u0018\u0003\u0002\u0002\u0002",
    "\u0002\u001a\u0003\u0002\u0002\u0002\u0002\u001c\u0003\u0002\u0002\u0002",
    "\u0002\u001e\u0003\u0002\u0002\u0002\u0003$\u0003\u0002\u0002\u0002",
    "\u0003&\u0003\u0002\u0002\u0002\u0003(\u0003\u0002\u0002\u0002\u0004",
    "*\u0003\u0002\u0002\u0002\u0006,\u0003\u0002\u0002\u0002\b.\u0003\u0002",
    "\u0002\u0002\n0\u0003\u0002\u0002\u0002\f2\u0003\u0002\u0002\u0002\u000e",
    "\u00fc\u0003\u0002\u0002\u0002\u0010\u0104\u0003\u0002\u0002\u0002\u0012",
    "\u0106\u0003\u0002\u0002\u0002\u0014\u0111\u0003\u0002\u0002\u0002\u0016",
    "\u0116\u0003\u0002\u0002\u0002\u0018\u0135\u0003\u0002\u0002\u0002\u001a",
    "\u0138\u0003\u0002\u0002\u0002\u001c\u0144\u0003\u0002\u0002\u0002\u001e",
    "\u014a\u0003\u0002\u0002\u0002 \u0150\u0003\u0002\u0002\u0002\"\u0153",
    "\u0003\u0002\u0002\u0002$\u0157\u0003\u0002\u0002\u0002&\u0160\u0003",
    "\u0002\u0002\u0002(\u0165\u0003\u0002\u0002\u0002*+\t\u0002\u0002\u0002",
    "+\u0005\u0003\u0002\u0002\u0002,-\t\u0003\u0002\u0002-\u0007\u0003\u0002",
    "\u0002\u0002./\u0007*\u0002\u0002/\t\u0003\u0002\u0002\u000201\u0007",
    "+\u0002\u00021\u000b\u0003\u0002\u0002\u000223\u0007.\u0002\u00023\r",
    "\u0003\u0002\u0002\u000245\u0007u\u0002\u000256\u0007k\u0002\u00026",
    "\u00fd\u0007p\u0002\u000278\u0007e\u0002\u000289\u0007q\u0002\u0002",
    "9\u00fd\u0007u\u0002\u0002:;\u0007n\u0002\u0002;<\u0007q\u0002\u0002",
    "<\u00fd\u0007i\u0002\u0002=>\u0007g\u0002\u0002>?\u0007z\u0002\u0002",
    "?\u00fd\u0007r\u0002\u0002@A\u0007g\u0002\u0002AB\u0007z\u0002\u0002",
    "BC\u0007r\u0002\u0002C\u00fd\u00074\u0002\u0002DE\u0007k\u0002\u0002",
    "EF\u0007p\u0002\u0002FG\u0007v\u0002\u0002GH\u0007G\u0002\u0002HI\u0007",
    "z\u0002\u0002IJ\u0007r\u0002\u0002J\u00fd\u00074\u0002\u0002KL\u0007",
    "n\u0002\u0002LM\u0007q\u0002\u0002MN\u0007i\u0002\u0002N\u00fd\u0007",
    "4\u0002\u0002OP\u0007g\u0002\u0002PQ\u0007z\u0002\u0002QR\u0007r\u0002",
    "\u0002RS\u00073\u0002\u0002S\u00fd\u00072\u0002\u0002TU\u0007k\u0002",
    "\u0002UV\u0007p\u0002\u0002VW\u0007v\u0002\u0002WX\u0007G\u0002\u0002",
    "XY\u0007z\u0002\u0002YZ\u0007r\u0002\u0002Z[\u00073\u0002\u0002[\u00fd",
    "\u00072\u0002\u0002\\]\u0007n\u0002\u0002]^\u0007q\u0002\u0002^_\u0007",
    "i\u0002\u0002_`\u00073\u0002\u0002`\u00fd\u00072\u0002\u0002ab\u0007",
    "u\u0002\u0002bc\u0007s\u0002\u0002cd\u0007t\u0002\u0002d\u00fd\u0007",
    "v\u0002\u0002ef\u0007e\u0002\u0002fg\u0007d\u0002\u0002gh\u0007t\u0002",
    "\u0002h\u00fd\u0007v\u0002\u0002ij\u0007g\u0002\u0002jk\u0007t\u0002",
    "\u0002k\u00fd\u0007h\u0002\u0002lm\u0007g\u0002\u0002mn\u0007t\u0002",
    "\u0002no\u0007h\u0002\u0002o\u00fd\u0007e\u0002\u0002pq\u0007n\u0002",
    "\u0002qr\u0007i\u0002\u0002rs\u0007c\u0002\u0002st\u0007o\u0002\u0002",
    "tu\u0007o\u0002\u0002u\u00fd\u0007c\u0002\u0002vw\u0007v\u0002\u0002",
    "wx\u0007i\u0002\u0002xy\u0007c\u0002\u0002yz\u0007o\u0002\u0002z{\u0007",
    "o\u0002\u0002{\u00fd\u0007c\u0002\u0002|}\u0007v\u0002\u0002}~\u0007",
    "c\u0002\u0002~\u00fd\u0007p\u0002\u0002\u007f\u0080\u0007c\u0002\u0002",
    "\u0080\u0081\u0007u\u0002\u0002\u0081\u0082\u0007k\u0002\u0002\u0082",
    "\u00fd\u0007p\u0002\u0002\u0083\u0084\u0007c\u0002\u0002\u0084\u0085",
    "\u0007e\u0002\u0002\u0085\u0086\u0007q\u0002\u0002\u0086\u00fd\u0007",
    "u\u0002\u0002\u0087\u0088\u0007c\u0002\u0002\u0088\u0089\u0007v\u0002",
    "\u0002\u0089\u008a\u0007c\u0002\u0002\u008a\u00fd\u0007p\u0002\u0002",
    "\u008b\u008c\u0007u\u0002\u0002\u008c\u008d\u0007k\u0002\u0002\u008d",
    "\u008e\u0007p\u0002\u0002\u008e\u00fd\u0007j\u0002\u0002\u008f\u0090",
    "\u0007e\u0002\u0002\u0090\u0091\u0007q\u0002\u0002\u0091\u0092\u0007",
    "u\u0002\u0002\u0092\u00fd\u0007j\u0002\u0002\u0093\u0094\u0007v\u0002",
    "\u0002\u0094\u0095\u0007c\u0002\u0002\u0095\u0096\u0007p\u0002\u0002",
    "\u0096\u00fd\u0007j\u0002\u0002\u0097\u0098\u0007c\u0002\u0002\u0098",
    "\u0099\u0007u\u0002\u0002\u0099\u009a\u0007k\u0002\u0002\u009a\u009b",
    "\u0007p\u0002\u0002\u009b\u00fd\u0007j\u0002\u0002\u009c\u009d\u0007",
    "c\u0002\u0002\u009d\u009e\u0007e\u0002\u0002\u009e\u009f\u0007q\u0002",
    "\u0002\u009f\u00a0\u0007u\u0002\u0002\u00a0\u00fd\u0007j\u0002\u0002",
    "\u00a1\u00a2\u0007c\u0002\u0002\u00a2\u00a3\u0007v\u0002\u0002\u00a3",
    "\u00a4\u0007c\u0002\u0002\u00a4\u00a5\u0007p\u0002\u0002\u00a5\u00fd",
    "\u0007j\u0002\u0002\u00a6\u00a7\u0007u\u0002\u0002\u00a7\u00a8\u0007",
    "k\u0002\u0002\u00a8\u00a9\u0007i\u0002\u0002\u00a9\u00fd\u0007p\u0002",
    "\u0002\u00aa\u00ab\u0007u\u0002\u0002\u00ab\u00ac\u0007k\u0002\u0002",
    "\u00ac\u00ad\u0007i\u0002\u0002\u00ad\u00ae\u0007o\u0002\u0002\u00ae",
    "\u00af\u0007q\u0002\u0002\u00af\u00b0\u0007k\u0002\u0002\u00b0\u00fd",
    "\u0007f\u0002\u0002\u00b1\u00b2\u0007f\u0002\u0002\u00b2\u00b3\u0007",
    "g\u0002\u0002\u00b3\u00b4\u0007i\u0002\u0002\u00b4\u00b5\u0007t\u0002",
    "\u0002\u00b5\u00b6\u0007g\u0002\u0002\u00b6\u00b7\u0007g\u0002\u0002",
    "\u00b7\u00fd\u0007u\u0002\u0002\u00b8\u00b9\u0007t\u0002\u0002\u00b9",
    "\u00ba\u0007c\u0002\u0002\u00ba\u00bb\u0007f\u0002\u0002\u00bb\u00bc",
    "\u0007k\u0002\u0002\u00bc\u00bd\u0007c\u0002\u0002\u00bd\u00be\u0007",
    "p\u0002\u0002\u00be\u00fd\u0007u\u0002\u0002\u00bf\u00c0\u0007h\u0002",
    "\u0002\u00c0\u00c1\u0007c\u0002\u0002\u00c1\u00c2\u0007e\u0002\u0002",
    "\u00c2\u00c3\u0007v\u0002\u0002\u00c3\u00c4\u0007q\u0002\u0002\u00c4",
    "\u00c5\u0007t\u0002\u0002\u00c5\u00c6\u0007k\u0002\u0002\u00c6\u00c7",
    "\u0007c\u0002\u0002\u00c7\u00fd\u0007n\u0002\u0002\u00c8\u00c9\u0007",
    "p\u0002\u0002\u00c9\u00ca\u0007g\u0002\u0002\u00ca\u00cb\u0007i\u0002",
    "\u0002\u00cb\u00cc\u0007c\u0002\u0002\u00cc\u00cd\u0007v\u0002\u0002",
    "\u00cd\u00fd\u0007g\u0002\u0002\u00ce\u00cf\u0007c\u0002\u0002\u00cf",
    "\u00d0\u0007d\u0002\u0002\u00d0\u00fd\u0007u\u0002\u0002\u00d1\u00d2",
    "\u0007e\u0002\u0002\u00d2\u00d3\u0007g\u0002\u0002\u00d3\u00d4\u0007",
    "k\u0002\u0002\u00d4\u00fd\u0007n\u0002\u0002\u00d5\u00d6\u0007h\u0002",
    "\u0002\u00d6\u00d7\u0007n\u0002\u0002\u00d7\u00d8\u0007q\u0002\u0002",
    "\u00d8\u00d9\u0007q\u0002\u0002\u00d9\u00fd\u0007t\u0002\u0002\u00da",
    "\u00db\u0007v\u0002\u0002\u00db\u00dc\u0007t\u0002\u0002\u00dc\u00dd",
    "\u0007w\u0002\u0002\u00dd\u00de\u0007p\u0002\u0002\u00de\u00fd\u0007",
    "e\u0002\u0002\u00df\u00e0\u0007t\u0002\u0002\u00e0\u00e1\u0007q\u0002",
    "\u0002\u00e1\u00e2\u0007w\u0002\u0002\u00e2\u00e3\u0007p\u0002\u0002",
    "\u00e3\u00fd\u0007f\u0002\u0002\u00e4\u00e5\u0007t\u0002\u0002\u00e5",
    "\u00e6\u0007q\u0002\u0002\u00e6\u00e7\u0007w\u0002\u0002\u00e7\u00e8",
    "\u0007p\u0002\u0002\u00e8\u00e9\u0007f\u0002\u0002\u00e9\u00ea\u0007",
    "V\u0002\u0002\u00ea\u00eb\u0007q\u0002\u0002\u00eb\u00ec\u0007G\u0002",
    "\u0002\u00ec\u00ed\u0007z\u0002\u0002\u00ed\u00ee\u0007r\u0002\u0002",
    "\u00ee\u00fd\u00074\u0002\u0002\u00ef\u00f0\u0007t\u0002\u0002\u00f0",
    "\u00f1\u0007q\u0002\u0002\u00f1\u00f2\u0007w\u0002\u0002\u00f2\u00f3",
    "\u0007p\u0002\u0002\u00f3\u00f4\u0007f\u0002\u0002\u00f4\u00f5\u0007",
    "F\u0002\u0002\u00f5\u00f6\u0007w\u0002\u0002\u00f6\u00f7\u0007t\u0002",
    "\u0002\u00f7\u00f8\u0007c\u0002\u0002\u00f8\u00f9\u0007v\u0002\u0002",
    "\u00f9\u00fa\u0007k\u0002\u0002\u00fa\u00fb\u0007q\u0002\u0002\u00fb",
    "\u00fd\u0007p\u0002\u0002\u00fc4\u0003\u0002\u0002\u0002\u00fc7\u0003",
    "\u0002\u0002\u0002\u00fc:\u0003\u0002\u0002\u0002\u00fc=\u0003\u0002",
    "\u0002\u0002\u00fc@\u0003\u0002\u0002\u0002\u00fcD\u0003\u0002\u0002",
    "\u0002\u00fcK\u0003\u0002\u0002\u0002\u00fcO\u0003\u0002\u0002\u0002",
    "\u00fcT\u0003\u0002\u0002\u0002\u00fc\\\u0003\u0002\u0002\u0002\u00fc",
    "a\u0003\u0002\u0002\u0002\u00fce\u0003\u0002\u0002\u0002\u00fci\u0003",
    "\u0002\u0002\u0002\u00fcl\u0003\u0002\u0002\u0002\u00fcp\u0003\u0002",
    "\u0002\u0002\u00fcv\u0003\u0002\u0002\u0002\u00fc|\u0003\u0002\u0002",
    "\u0002\u00fc\u007f\u0003\u0002\u0002\u0002\u00fc\u0083\u0003\u0002\u0002",
    "\u0002\u00fc\u0087\u0003\u0002\u0002\u0002\u00fc\u008b\u0003\u0002\u0002",
    "\u0002\u00fc\u008f\u0003\u0002\u0002\u0002\u00fc\u0093\u0003\u0002\u0002",
    "\u0002\u00fc\u0097\u0003\u0002\u0002\u0002\u00fc\u009c\u0003\u0002\u0002",
    "\u0002\u00fc\u00a1\u0003\u0002\u0002\u0002\u00fc\u00a6\u0003\u0002\u0002",
    "\u0002\u00fc\u00aa\u0003\u0002\u0002\u0002\u00fc\u00b1\u0003\u0002\u0002",
    "\u0002\u00fc\u00b8\u0003\u0002\u0002\u0002\u00fc\u00bf\u0003\u0002\u0002",
    "\u0002\u00fc\u00c8\u0003\u0002\u0002\u0002\u00fc\u00ce\u0003\u0002\u0002",
    "\u0002\u00fc\u00d1\u0003\u0002\u0002\u0002\u00fc\u00d5\u0003\u0002\u0002",
    "\u0002\u00fc\u00da\u0003\u0002\u0002\u0002\u00fc\u00df\u0003\u0002\u0002",
    "\u0002\u00fc\u00e4\u0003\u0002\u0002\u0002\u00fc\u00ef\u0003\u0002\u0002",
    "\u0002\u00fd\u000f\u0003\u0002\u0002\u0002\u00fe\u00ff\u0007o\u0002",
    "\u0002\u00ff\u0100\u0007k\u0002\u0002\u0100\u0105\u0007p\u0002\u0002",
    "\u0101\u0102\u0007o\u0002\u0002\u0102\u0103\u0007c\u0002\u0002\u0103",
    "\u0105\u0007z\u0002\u0002\u0104\u00fe\u0003\u0002\u0002\u0002\u0104",
    "\u0101\u0003\u0002\u0002\u0002\u0105\u0011\u0003\u0002\u0002\u0002\u0106",
    "\u0107\u0007e\u0002\u0002\u0107\u0108\u0007q\u0002\u0002\u0108\u0109",
    "\u0007o\u0002\u0002\u0109\u010a\u0007r\u0002\u0002\u010a\u010b\u0007",
    "n\u0002\u0002\u010b\u010c\u0007g\u0002\u0002\u010c\u010d\u0007v\u0002",
    "\u0002\u010d\u010e\u0007k\u0002\u0002\u010e\u010f\u0007q\u0002\u0002",
    "\u010f\u0110\u0007p\u0002\u0002\u0110\u0013\u0003\u0002\u0002\u0002",
    "\u0111\u0112\u0007c\u0002\u0002\u0112\u0113\u0007v\u0002\u0002\u0113",
    "\u0114\u0007v\u0002\u0002\u0114\u0115\u0007t\u0002\u0002\u0115\u0015",
    "\u0003\u0002\u0002\u0002\u0116\u0117\u0007u\u0002\u0002\u0117\u0118",
    "\u0007v\u0002\u0002\u0118\u0119\u0007g\u0002\u0002\u0119\u011a\u0007",
    "r\u0002\u0002\u011a\u0017\u0003\u0002\u0002\u0002\u011b\u011c\u0007",
    "r\u0002\u0002\u011c\u0136\u0007k\u0002\u0002\u011d\u0136\u0007g\u0002",
    "\u0002\u011e\u011f\u0007t\u0002\u0002\u011f\u0120\u0007c\u0002\u0002",
    "\u0120\u0121\u0007p\u0002\u0002\u0121\u0136\u0007f\u0002\u0002\u0122",
    "\u0123\u0007t\u0002\u0002\u0123\u0124\u0007c\u0002\u0002\u0124\u0125",
    "\u0007p\u0002\u0002\u0125\u0126\u0007f\u0002\u0002\u0126\u0127\u0007",
    "8\u0002\u0002\u0127\u0136\u00076\u0002\u0002\u0128\u0129\u0007t\u0002",
    "\u0002\u0129\u012a\u0007c\u0002\u0002\u012a\u012b\u0007p\u0002\u0002",
    "\u012b\u012c\u0007f\u0002\u0002\u012c\u012d\u0007E\u0002\u0002\u012d",
    "\u012e\u0007c\u0002\u0002\u012e\u012f\u0007p\u0002\u0002\u012f\u0130",
    "\u0007q\u0002\u0002\u0130\u0131\u0007p\u0002\u0002\u0131\u0132\u0007",
    "k\u0002\u0002\u0132\u0133\u0007e\u0002\u0002\u0133\u0134\u0007c\u0002",
    "\u0002\u0134\u0136\u0007n\u0002\u0002\u0135\u011b\u0003\u0002\u0002",
    "\u0002\u0135\u011d\u0003\u0002\u0002\u0002\u0135\u011e\u0003\u0002\u0002",
    "\u0002\u0135\u0122\u0003\u0002\u0002\u0002\u0135\u0128\u0003\u0002\u0002",
    "\u0002\u0136\u0019\u0003\u0002\u0002\u0002\u0137\u0139\u00042;\u0002",
    "\u0138\u0137\u0003\u0002\u0002\u0002\u0139\u013a\u0003\u0002\u0002\u0002",
    "\u013a\u0138\u0003\u0002\u0002\u0002\u013a\u013b\u0003\u0002\u0002\u0002",
    "\u013b\u0142\u0003\u0002\u0002\u0002\u013c\u013e\u00070\u0002\u0002",
    "\u013d\u013f\u00042;\u0002\u013e\u013d\u0003\u0002\u0002\u0002\u013f",
    "\u0140\u0003\u0002\u0002\u0002\u0140\u013e\u0003\u0002\u0002\u0002\u0140",
    "\u0141\u0003\u0002\u0002\u0002\u0141\u0143\u0003\u0002\u0002\u0002\u0142",
    "\u013c\u0003\u0002\u0002\u0002\u0142\u0143\u0003\u0002\u0002\u0002\u0143",
    "\u001b\u0003\u0002\u0002\u0002\u0144\u0145\u0007&\u0002\u0002\u0145",
    "\u0146\u0007}\u0002\u0002\u0146\u0147\u0003\u0002\u0002\u0002\u0147",
    "\u0148\b\u000e\u0002\u0002\u0148\u001d\u0003\u0002\u0002\u0002\u0149",
    "\u014b\t\u0004\u0002\u0002\u014a\u0149\u0003\u0002\u0002\u0002\u014b",
    "\u014c\u0003\u0002\u0002\u0002\u014c\u014a\u0003\u0002\u0002\u0002\u014c",
    "\u014d\u0003\u0002\u0002\u0002\u014d\u014e\u0003\u0002\u0002\u0002\u014e",
    "\u014f\b\u000f\u0003\u0002\u014f\u001f\u0003\u0002\u0002\u0002\u0150",
    "\u0151\t\u0004\u0002\u0002\u0151!\u0003\u0002\u0002\u0002\u0152\u0154",
    "\n\u0005\u0002\u0002\u0153\u0152\u0003\u0002\u0002\u0002\u0154\u0155",
    "\u0003\u0002\u0002\u0002\u0155\u0153\u0003\u0002\u0002\u0002\u0155\u0156",
    "\u0003\u0002\u0002\u0002\u0156#\u0003\u0002\u0002\u0002\u0157\u015d",
    "\u0005\"\u0011\u0002\u0158\u0159\u0005 \u0010\u0002\u0159\u015a\u0005",
    "\"\u0011\u0002\u015a\u015c\u0003\u0002\u0002\u0002\u015b\u0158\u0003",
    "\u0002\u0002\u0002\u015c\u015f\u0003\u0002\u0002\u0002\u015d\u015b\u0003",
    "\u0002\u0002\u0002\u015d\u015e\u0003\u0002\u0002\u0002\u015e%\u0003",
    "\u0002\u0002\u0002\u015f\u015d\u0003\u0002\u0002\u0002\u0160\u0161\u0007",
    "\u007f\u0002\u0002\u0161\u0162\u0003\u0002\u0002\u0002\u0162\u0163\b",
    "\u0013\u0004\u0002\u0163\'\u0003\u0002\u0002\u0002\u0164\u0166\t\u0004",
    "\u0002\u0002\u0165\u0164\u0003\u0002\u0002\u0002\u0166\u0167\u0003\u0002",
    "\u0002\u0002\u0167\u0165\u0003\u0002\u0002\u0002\u0167\u0168\u0003\u0002",
    "\u0002\u0002\u0168\u0169\u0003\u0002\u0002\u0002\u0169\u016a\b\u0014",
    "\u0003\u0002\u016a)\u0003\u0002\u0002\u0002\u000e\u0002\u0003\u00fc",
    "\u0104\u0135\u013a\u0140\u0142\u014c\u0155\u015d\u0167\u0005\u0004\u0003",
    "\u0002\b\u0002\u0002\u0004\u0002\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function CustomAxisLexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

CustomAxisLexer.prototype = Object.create(antlr4.Lexer.prototype);
CustomAxisLexer.prototype.constructor = CustomAxisLexer;

Object.defineProperty(CustomAxisLexer.prototype, "atn", {
        get : function() {
                return atn;
        }
});

CustomAxisLexer.EOF = antlr4.Token.EOF;
CustomAxisLexer.MULTIPLY_OPERATORS = 1;
CustomAxisLexer.ADDITION_OPERATORS = 2;
CustomAxisLexer.BEGIN_PARENTHESIS = 3;
CustomAxisLexer.END_PARENTHESIS = 4;
CustomAxisLexer.COMMA = 5;
CustomAxisLexer.FUNCTION = 6;
CustomAxisLexer.VARIADIC_FUNCTION = 7;
CustomAxisLexer.COMPLETION_FUNCTION = 8;
CustomAxisLexer.RUN_ATTRIBUTE_FUNCTION = 9;
CustomAxisLexer.STEP = 10;
CustomAxisLexer.NAMED_CONSTANT = 11;
CustomAxisLexer.NUMBER_LITERAL = 12;
CustomAxisLexer.BEGIN_SUBSTITUTION = 13;
CustomAxisLexer.WS = 14;
CustomAxisLexer.ATTRIBUTE_NAME = 15;
CustomAxisLexer.END_SUBSTITUTION = 16;
CustomAxisLexer.WS2 = 17;

CustomAxisLexer.SUBSTITUTION = 1;

CustomAxisLexer.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

CustomAxisLexer.prototype.modeNames = [ "DEFAULT_MODE", "SUBSTITUTION" ];

CustomAxisLexer.prototype.literalNames = [ null, null, null, "'('", "')'", 
                                           "','", null, null, "'completion'", 
                                           "'attr'", "'step'", null, null, 
                                           "'${'", null, null, "'}'" ];

CustomAxisLexer.prototype.symbolicNames = [ null, "MULTIPLY_OPERATORS", 
                                            "ADDITION_OPERATORS", "BEGIN_PARENTHESIS", 
                                            "END_PARENTHESIS", "COMMA", 
                                            "FUNCTION", "VARIADIC_FUNCTION", 
                                            "COMPLETION_FUNCTION", "RUN_ATTRIBUTE_FUNCTION", 
                                            "STEP", "NAMED_CONSTANT", "NUMBER_LITERAL", 
                                            "BEGIN_SUBSTITUTION", "WS", 
                                            "ATTRIBUTE_NAME", "END_SUBSTITUTION", 
                                            "WS2" ];

CustomAxisLexer.prototype.ruleNames = [ "MULTIPLY_OPERATORS", "ADDITION_OPERATORS", 
                                        "BEGIN_PARENTHESIS", "END_PARENTHESIS", 
                                        "COMMA", "FUNCTION", "VARIADIC_FUNCTION", 
                                        "COMPLETION_FUNCTION", "RUN_ATTRIBUTE_FUNCTION", 
                                        "STEP", "NAMED_CONSTANT", "NUMBER_LITERAL", 
                                        "BEGIN_SUBSTITUTION", "WS", "WHITESPACE", 
                                        "ATTRIBUTE_NAME_REGEX", "ATTRIBUTE_NAME", 
                                        "END_SUBSTITUTION", "WS2" ];

CustomAxisLexer.prototype.grammarFileName = "CustomAxisLexer.g4";


export { CustomAxisLexer };

